import React, { useEffect, useState } from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import AOS from 'aos'
import { RouterProvider } from 'react-router-dom'
// import WalletProvider from '../src/wallets/provider/WalletProvider'

import { Layout } from './components/layout'
import AppRoutes from './routes/AppRoutes'

import 'bootstrap/dist/css/bootstrap.min.css'
import '../src/styles/globals.scss'
import 'aos/dist/aos.css'
import WalletProvider from 'wallet-module/provider/WalletProvider'
export const AppContext = React.createContext(null)
export default function App() {
  const queryClient = new QueryClient()

  const [appState, setAppState] = useState({})
  useEffect(() => {
    AOS.init()
  }, [])

  return (
    <>
      <AppContext.Provider value={{ appState, setAppState }}>
        <WalletProvider
          infuraKey={process.env.REACT_APP_INFURA_KEY}
          supportedChainID={Number(process.env.REACT_APP_SUPPORTED_CHAIN)}
          walletConnectProjectID={process.env.REACT_APP_WALLET_CONNECT_PROJECT_ID}>
          <QueryClientProvider client={queryClient}>
            <Layout>
              <RouterProvider router={AppRoutes} />
            </Layout>
          </QueryClientProvider>
        </WalletProvider>
      </AppContext.Provider>
    </>
  )
}
